import { render, staticRenderFns } from "./AddProductPage.vue?vue&type=template&id=b9a9ca36&"
import script from "./AddProductPage.vue?vue&type=script&lang=js&"
export * from "./AddProductPage.vue?vue&type=script&lang=js&"
import style0 from "./AddProductPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports